import { render } from "./AddIcon.vue?vue&type=template&id=cbc9c740"
const script = {}
script.render = render

export default script